import { useCheckLoadedAndShow } from '../hooks/useCheckLoadedAndShow';
import { execJsInSdk } from '../integration-utils';
var removeIncorrectLoginForm = function () {
    return execJsInSdk(function () {
        [
            '#password',
            '#userid',
            '#useridLabel',
            '#passwordLabel',
            '#orText',
            '.signinWidth',
            '.forgotLink',
        ].forEach(function (selector) {
            document.querySelectorAll(selector).forEach(function (x) { return x.remove(); });
        });
    });
};
export function useKroger() {
    useCheckLoadedAndShow(removeIncorrectLoginForm);
}
